import { render, staticRenderFns } from "./LayoutDesigner.vue?vue&type=template&id=1996ac2c"
import script from "./LayoutDesigner.vue?vue&type=script&lang=js"
export * from "./LayoutDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports